import EmailValidator, {EMAIL_ERRORS} from "./email";
import PasswordValidator, {PASSWORD_ERRORS} from "./password";
import PhoneValidator, {PHONE_ERRORS} from "./phone";
import CommonValidator, {COMMON_ERRORS} from "./common";
import CreditCardValidator, {CREDIT_CARD_MESSAGES} from "./creditCard";
import ZipValidator, {ZIP_ERROR_MESSAGES} from "./zip";

export default class Index {
  constructor() {
    this.EmailValidator = EmailValidator;
    this.PasswordValidator = PasswordValidator;
    this.PhoneValidator = PhoneValidator;
    this.CommonValidator = CommonValidator;
    this.CreditCardValidator = CreditCardValidator;
    this.ZipValidator = ZipValidator;

    this.Errors = {
      EMAIL_ERRORS,
      PASSWORD_ERRORS,
      PHONE_ERRORS,
      COMMON_ERRORS,
      CREDIT_CARD_MESSAGES,
      ZIP_ERROR_MESSAGES,
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/services/validation/index.js